// extracted by mini-css-extract-plugin
export default {"deleteButton":"SLAFieldset_deleteButton__jrzsS","space":"SLAFieldset_space__mk22V"};